import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const statItems = [
  { id: 1, name: 'Tiefbautrassen (m)', value: '> 210.000', icon: 'Map' },
  { id: 2, name: 'Hausanschlüsse NE3', value: '> 4.900', icon: 'Home' },
  { id: 3, name: 'Wohnungsanschlüsse NE4', value: '9.950', icon: 'Wifi' },
  { id: 4, name: 'Mitarbeiter im Einsatz', value: '69', icon: 'Users' },
];

const Stats = () => {
  return (
    <section id="stats" className="py-16 bg-slate-900 relative z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {statItems.map((stat, index) => (
            <motion.div
              key={stat.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-amber-500/50 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="p-3 bg-amber-500/10 rounded-lg">
                  <SafeIcon name={stat.icon} className="h-6 w-6 text-amber-500" />
                </div>
              </div>
              <p className="text-3xl font-extrabold text-white mb-1">{stat.value}</p>
              <p className="text-sm font-medium text-slate-400">{stat.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;